import { useGetProjectQuery } from 'features/entry-form-v2/data/useGetProjectQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

export const useIsSurveyFeatureEnabled = () => {
	const flags = useFlags();
	return !!flags['teamCoreSurveySurveyEnabled'];
};

export const useIsSurveyEnabledForProject = (): boolean => {
	const isSurveyFeatureEnabled = useIsSurveyFeatureEnabled();
	const flags = useFlags();
	// We need to exclude this feature for all projects in HSØ so non-HSØ users that are
	// invited to a HSØ project can't send surveys
	const excludedOrgId = flags['teamCoreSurveyOrgDisabled'] as string | undefined;

	const params = useParams<{ projectId?: string; id?: string }>();
	const projectId = params.projectId || params.id;

	const projectQuery = useGetProjectQuery(
		{ projectId: projectId as string },
		{ enabled: !!(isSurveyFeatureEnabled && projectId) }
	);

	if (!isSurveyFeatureEnabled || excludedOrgId === undefined || !projectQuery.data) {
		return false;
	}

	const organizationId = projectQuery.data.project.organizations[0]?.organizationId;
	return organizationId?.toString() !== excludedOrgId;
};
